export enum EventStatus {
  DRAFT = 1,
  ACCEPTED = 2,
  CLOSED = 3,
  DELETED = 4,
}

export interface EventPublish {
  status: EventStatus;
}
